<template>
  <div class="full-m-tubiao-body">
    <div id="mTubiao" style="width: 100%; height: 100%"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "mTubiao",
  props: {
    rowData: {
      type: Array,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  mounted() {
    this.setEchart();
  },
  created() {},
  methods: {
    setEchart() {
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(document.getElementById("mTubiao"));
      // 指定图表的配置项和数据
      const option = {
        grid: {
          left: "10",
          top: "30",
          right: "10",
          bottom: "10",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "20",
            "21",
            "22",
            "23",
            "24",
          ],
          axisLabel: {
            textStyle: {
              color: "rgba(255,255,255,1)",
              fontSize: 14,
            },
          },
          axisLine: {
            lineStyle: {
              color: "rgba(255,255,255,.1)",
            },
          },
        },

        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "rgba(255,255,255,1)",
            },
          },
        },
        series: [
          {
            data: [
              0,
              0,
              0,
              0,
              0,
              0,
              0,
              80,
              0,
              0,
              0,
              0,
              0,
              60,
              0,
              0,
              0,
              0,
              0,
              0,
              80,
              0,
              0,
              0,
              0,
              0,
              0,
            ],
            type: "line",
            itemStyle: {
              normal: {
                color: "rgba(228, 228, 126, 1)",
                borderColor: "rgba(228, 228, 126, .1)",
                borderWidth: 12,
              },
            },
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
  },
};
</script>
<style lang="less" scoped>
.full-m-tubiao-body {
  padding: 20px 15px 15px 15px;
  height: 100%;
  overflow: hidden;
}
</style>
